module.exports = __webpack_public_path__ + "static/media/custom-parameter-settings.42269202.svg";